import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

//---helpers
import { PRODUCTS_ORDER_KEY } from '@/helpers';
import { globalLoader, pluralizate } from '@/helpers/variables';

//---mixins
import { dynamicHead } from '@/mixins/dynamic-head.js';

//---components
import ProductsBlock from '@/components/products/ProductsBlock/index.vue';
import Pagination from '@/components/@general/Pagination/index.vue';
import BreadcrumbsSimple from '@/components/@general/BreadcrumbsSimple/index.vue';

export default {
  name: 'Series',
  mixins: [dynamicHead],
  components: {
    BreadcrumbsSimple,
    ProductsBlock,
    Pagination
  },
  data() {
    return {
      seriesData: null,
      seriesProducts: [],
      seriesProductsMeta: null,
      isSeriesProductsLoading: false
    };
  },
  created() {
    this._loadContent();
  },
  watch: {
    $route: {
      immediate: false,
      handler(newVal) {
        if (newVal) {
          this._getProducts();
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      favourites: 'favorites/whichList'
    }),
    breadcrumbs() {
      return [{ title: this.$t('catalog'), route: { name: 'products' } }];
    },
    titlePluralizate() {
      return pluralizate(
        this.seriesProductsMeta ? this.seriesProductsMeta.total : 0,
        this.$t('label.products.countOne'),
        this.$t('label.products.countSimple'),
        this.$t('label.products.countMany')
      );
    },
    productsList() {
      if (!this.isAuthenticated || !this.favourites) {
        return this.seriesProducts;
      }

      const favourites = _.map(this.favourites, 'productId');
      const markAsSelected = (product) => {
        product.isFavorite = favourites.includes(product.id);
        return product;
      };

      return _.map(this.seriesProducts, markAsSelected);
    }
  },
  methods: {
    ...mapActions({
      getCatalogCategory: 'catalog/GET_CATALOG_CATEGORY',
      getCatalogProducts: 'catalog/GET_CATALOG_PRODUCTS'
    }),
    _getProducts() {
      this.isSeriesProductsLoading = true;
      let { params, query } = this.$route;
      let { seria, page } = params;
      let { orderby } = query;

      let requestParams = {
        page: page ? Number(page) : 1,
        sort_filter_type: orderby ? orderby : PRODUCTS_ORDER_KEY.BESTSELLERS
      };

      if (['collection', 'collection-paginated'].includes(this.$route.name)) {
        requestParams.collection = seria;
      } else {
        requestParams.brand_slug = seria;
      }

      return this.getCatalogProducts(requestParams)
        .then((result) => {
          this.seriesProducts = result.data;
          this.seriesProductsMeta = result.meta;
        })
        .finally(() => {
          this.isSeriesProductsLoading = false;
        });
    },
    async _loadContent() {
      globalLoader(true);
      let promiseCollection = [];
      let { seria } = this.$route.params;
      promiseCollection.push(this.getCatalogCategory(seria).then((result) => (this.seriesData = result.data)));
      promiseCollection.push(this._getProducts());
      await Promise.all(promiseCollection);
      this._setMetaParams();

      globalLoader(false);
    },
    _setMetaParams() {
      let { title, originalTitle, shortDescription, image } = this.seriesData;

      if (originalTitle || title)
        this.metaParams.title = `${originalTitle ? originalTitle : title}${this.$t('seo.metaTitleGeneral')}`;
      this.metaParams.description = `${shortDescription ? shortDescription : originalTitle} ${this.$t('seo.metaDescGeneral')}`;
      if (image) this.metaParams.image = image;
      this.setMeta();
    }
  }
};
